import React from "react";
import moment from "moment";
import axios from "axios";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Input,
  Row
} from "reactstrap";
import "./Calendar.css"
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faClock
} from "@fortawesome/free-solid-svg-icons";

import Success from "./Success";
library.add(faTimes, faCheck, faChevronLeft, faChevronRight, faClock);

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      formSuccess: false,
      isLoading: false,
      formData: {
        event_id: "",
        certification: "Certified Integrator (Full day)",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        company: ""
      }
    };

    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
      formSuccess: false
    });
  }

  handleChange(event) {
    const { formData } = this.state;
    formData[event.target.name] = event.target.value;
    this.setState({
      formData
    });
  }

  handleSubmit = (event, errors, values) => {
    this.setState({ errors, values });

    if (errors.length === 0) {
      const { formData } = this.state;
      formData.event_id = this.props.getEvent.id;

      this.setState({ formData, isLoading: true });

      axios.post(`/registration`, {
        event: formData.event_id,
        certification: formData.certification,
        firstname: formData.firstname,
        lastname: formData.lastname,
        email: formData.email,
        phone: formData.phone,
        company: formData.company
      })
        .then(res => {
          if (res.status === 200) {
            this.setState({
              formSuccess: true,
              isLoading: false,
              formData: { event_id: "", certification: "", firstname: "", lastname: "", email: "", phone: "", company: "" }
            });
          }
        })
    }
  }

  render() {
    const RegEvent = this.props.getEvent;
    return (
      <div className="register" id="popupss">
        <div className="reg-title">{RegEvent.title}</div>
        <div className="reg-time">
          <FontAwesomeIcon className="oi" icon="clock" />
          <span> {RegEvent.time}</span>
        </div>
        <div className="border-line" />
        <div className="section-block">
          <div className="section-title">{RegEvent.desc}</div>
          {RegEvent.price ? <p>€{RegEvent.price}</p> : ''}
          {/* <div className="section-details">Read Agenda</div> */}
          {RegEvent.apply_url ? <Button href={RegEvent.apply_url} className="int-btn blue-btn" target="_blank">REGISTER</Button> : <Button className="int-btn blue-btn" onClick={this.toggle}>
            REGISTER
          </Button>}

        </div>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          id="register-box"
          className="register-sucess"
        >
          {this.state.formSuccess && (
            <Success eventDetail={RegEvent} />
          )}
          {!this.state.formSuccess && (
            <div>
              <ModalHeader toggle={this.toggle}>
                <p className="head">Register</p>
                <p>{moment(RegEvent.date).format('dddd Do MMMM YYYY')}</p>
              </ModalHeader>
              <ModalBody>
                <AvForm id="registration_form" onSubmit={this.handleSubmit} autoComplete="on">
                  <FormGroup>
                    <Input type="select" name="certification" onChange={this.handleChange}>
                      <option>Certified Integrator (Full day)</option>
                      <option>Certification Only</option>
                      <option>Recertification Session</option>
                    </Input>
                  </FormGroup>
                  <Row>
                    <FormGroup className="col-6">
                      <AvField
                        type="text"
                        name="firstname"
                        onChange={this.handleChange}
                        placeholder="First Name*"
                        validate={{
                          required: { value: true, errorMessage: 'Please enter first name' },
                          pattern: { value: "^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff]*)$", errorMessage: 'Your name must be composed only with letters' },
                          maxLength: { value: 25, errorMessage: 'Your name must be maximum 25 characters' }
                        }}
                      />
                    </FormGroup>
                    <FormGroup className="col-6">
                      <AvField
                        type="text"
                        name="lastname"
                        onChange={this.handleChange}
                        placeholder="Last Name*"
                        validate={{
                          required: { value: true, errorMessage: 'Please enter last name' },
                          pattern: { value: '^[a-zA-ZäöåÄÖÅ]+$', errorMessage: 'Your name must be composed only with letters' },
                          maxLength: { value: 25, errorMessage: 'Your name must be maximum 25 characters' }
                        }}
                      />
                    </FormGroup>
                  </Row>
                  <FormGroup>
                    <AvField
                      type="email"
                      name="email"
                      onChange={this.handleChange}
                      placeholder="Email*"
                      required
                      errorMessage="Enter a valid email address"
                    />
                  </FormGroup>
                  <FormGroup>
                    <AvField
                      type="text"
                      name="phone"
                      onChange={this.handleChange}
                      placeholder="Phone Number"
                      validate={{
                        required: { value: false, errorMessage: 'Enter phone number' },
                        minLength: { value: 7, errorMessage: 'Your phone number must be minimum 7 characters' },
                        maxLength: { value: 20, errorMessage: 'Your phone number must be maximum 20 characters' }
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <AvField
                      type="text"
                      name="company"
                      onChange={this.handleChange}
                      id="companyname"
                      placeholder="Company Name*"
                      validate={{
                        required: { value: true, errorMessage: 'You must enter a company name' },
                      }}
                    />
                  </FormGroup>

                  <Button type="submit" className="int-btn blue-btn d-block mx-auto">SUBMIT</Button>
                  {this.state.isLoading && (
                    <div className="text-center">
                      <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                    </div>
                  )}
                </AvForm>
              </ModalBody>
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

export default Register;
